<template>
  <VaLayout>
    <template #top>
      <VaNavbar class="admin-navbar">
        <template #left>
          <div class="flex items-center gap-4">
            <RouterLink to="/admin" class="text-primary font-bold text-xl"> FBlead Admin </RouterLink>
            <div class="flex items-center gap-2 ml-6">
              <RouterLink
                :to="{ name: 'admin-payments' }"
                class="px-3 py-2 rounded text-sm font-medium transition-colors"
                :class="
                  isActive('admin-payments') ? 'bg-primary text-white' : 'text-secondary hover:bg-background-element'
                "
              >
                Payments
              </RouterLink>
              <RouterLink
                :to="{ name: 'admin-url-requests' }"
                class="px-3 py-2 rounded text-sm font-medium transition-colors"
                :class="
                  isActive('admin-url-requests')
                    ? 'bg-primary text-white'
                    : 'text-secondary hover:bg-background-element'
                "
              >
                URL Requests
              </RouterLink>
              <RouterLink
                :to="{ name: 'admin-pricing-plans' }"
                class="px-3 py-2 rounded text-sm font-medium transition-colors"
                :class="
                  isActive('admin-pricing-plans')
                    ? 'bg-primary text-white'
                    : 'text-secondary hover:bg-background-element'
                "
              >
                Pricing Plans
              </RouterLink>
              <RouterLink
                :to="{ name: 'admin-change-password' }"
                class="px-3 py-2 rounded text-sm font-medium transition-colors"
                :class="
                  isActive('admin-change-password')
                    ? 'bg-primary text-white'
                    : 'text-secondary hover:bg-background-element'
                "
              >
                Change Password
              </RouterLink>
              <RouterLink
                v-if="adminAuthStore.admin?.isSuper"
                :to="{ name: 'admin-create-user' }"
                class="px-3 py-2 rounded text-sm font-medium transition-colors"
                :class="
                  isActive('admin-create-user') ? 'bg-primary text-white' : 'text-secondary hover:bg-background-element'
                "
              >
                Create Admin
              </RouterLink>
            </div>
          </div>
        </template>
        <template #right>
          <div class="flex items-center gap-4">
            <span v-if="adminAuthStore.admin" class="text-secondary text-sm">
              {{ adminAuthStore.admin.name }}
            </span>
            <VaButton preset="secondary" size="small" @click="handleLogout"> Logout </VaButton>
          </div>
        </template>
      </VaNavbar>
    </template>

    <template #content>
      <main class="p-6">
        <RouterView />
      </main>
    </template>
  </VaLayout>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAdminAuthStore } from '../stores/admin-auth-store'
import { useNotifications } from '../composables/useNotifications'

const router = useRouter()
const route = useRoute()
const adminAuthStore = useAdminAuthStore()
const { showSuccess } = useNotifications()

const isActive = (routeName: string) => {
  return route.name === routeName
}

onMounted(() => {
  adminAuthStore.initAuth()
  if (!adminAuthStore.isAuthenticated()) {
    router.push('/admin/login')
  }
})

const handleLogout = () => {
  adminAuthStore.clearAuth()
  showSuccess('Logged out successfully')
  router.push('/admin/login')
}
</script>

<style scoped>
.admin-navbar {
  border-bottom: 1px solid var(--va-background-element);
}
</style>
